import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { AppStoreState } from '@interfaces/app-store-state';
import { Features } from '@modules/company/company-core/store/consistency-checks/consistency-checks.types';

import { ConsistencyChecksFeaturesActions, reset } from './consistency-checks-actions';

@Injectable({
  providedIn: 'root'
})
export class ConsistencyChecksService {
  constructor(private store: Store<AppStoreState>) {}

  expireAllFromSelectedAccountingPeriod(): void {
    this.expireForKey('loans');
    this.expireForKey('immobilisations');
    this.expireForKey('fiscalResults');
    this.expireForKey('balance');
    this.expireForKey('resultAllocations');
  }

  loadConsistencyChecksLoans(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.loans.load());
  }

  loadConsistencyChecksBalance(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.balance.load());
  }

  loadConsistencyChecksImmobilisations(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.immobilisations.load());
  }

  loadConsistencyChecksFiscalResults(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.fiscalResults.load());
  }

  loadConsistencyChecksVatFramework(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.vatFramework.load());
  }

  loadConsistencyChecksCaFramework(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.caFramework.load());
  }

  loadConsistencyChecksLabels(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.labels.load());
  }

  loadConsistencyChecksPcgEntries(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.pcgEntries.load());
  }

  loadConsistencyChecksTransactions(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.transactions.load());
  }

  loadConsistencyChecksPersons(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.persons.load());
  }

  loadConsistencyChecksAccountingPeriods(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.accountingPeriods.load());
  }

  loadConsistencyChecksCompanies(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.companies.load());
  }

  loadConsistencyChecksBankAccounts(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.bankAccounts.load());
  }

  loadConsistencyChecksResultAllocations(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.resultAllocations.load());
  }

  loadConsistencyChecksTns(): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions.tns.load());
  }

  loadForKey(key: Features): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions[key].load());
  }

  expireForKey(key: Features): void {
    this.store.dispatch(ConsistencyChecksFeaturesActions[key].expire());
  }

  reset(): void {
    this.store.dispatch(reset());
  }
}
